import React from 'react';
import { IShapeProps } from './types';
import { Image } from 'react-konva';
import Konva from 'konva';

const CustomCanvasElement: React.FC<IShapeProps> = (props) => {

  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.Image>);

  return (
    <Image
      {...props.renderProps}
      ref={shapeRef}
      fillPatternImage={undefined}
      image={props.renderProps?.fillPatternImage}
    />
  );
}

export default CustomCanvasElement;